export const pause = {
  pause: {
    shape:
      '<path style="color:#000;fill:#22CCD8;stroke-linecap:round;stroke-linejoin:round" d="M7.168 0a.497.497 0 0 0-.498.498v13.004a.497.497 0 0 0 .498.498h3.334a.497.497 0 0 0 .498-.498V.498A.497.497 0 0 0 10.502 0Zm.496.994h2.342v12.012H7.664Zm2.839-.497H7.168v13.006h3.335zM.498 0A.497.497 0 0 0 0 .498v13.004A.497.497 0 0 0 .498 14h3.334a.497.497 0 0 0 .498-.498V.498A.497.497 0 0 0 3.832 0Zm.496.994h2.342v12.012H.994ZM3.832.497H.497v13.006h3.335Z"/>',
    viewBox: [0, 0, 10, 15],
  },
};
